import type { JSX } from 'react';

import { Radio } from 'antd';
import { MAlert, MTypography, WarningAlertDescription } from 'src/lib';
import { Color } from 'src/styles';

import * as Styles from './PaymentTypeHeader.styles';

interface PaymentTypeHeaderProps {
  checked: boolean;
  title: string;
  subtitle?: string | JSX.Element;
  disclaimer?: string | null;
  dataTestId?: string;
  onDisclaimer?: () => void;
}

export const PaymentTypeHeader = ({
  title,
  subtitle,
  disclaimer,
  checked,
  onDisclaimer,
  dataTestId,
}: PaymentTypeHeaderProps) => {
  const _onDisclaimer = () => {
    if (onDisclaimer) {
      onDisclaimer();
    }
  };

  return (
    <div className={Styles.header}>
      <div className={Styles.container}>
        <Radio checked={checked} />
        <MTypography variant='body1' testId={dataTestId}>
          {title}
        </MTypography>
      </div>
      <div className={Styles.subContainer}>
        {disclaimer && (
          <MAlert
            type='warning'
            showIcon={false}
            description={<WarningAlertDescription onClick={_onDisclaimer} text={disclaimer} />}
            className={Styles.alert}
          />
        )}
        {subtitle && (
          <MTypography variant='body2' color={Color.Gray6} className={Styles.subtitle}>
            {subtitle}
          </MTypography>
        )}
      </div>
    </div>
  );
};
